<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="handleDownloadCsv(titleChart)" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="matrix && matrix.length > 0">
    <study-completion :height="height" v-if="matrix && matrix.length > 0" :matrixData="matrix" :total="total" :totalActivity="totalActivity" slot="body" @onScrollTable="onScrollTable" />
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import Vue from "vue";
import _ from "lodash";

import ChartContainer from "./chart-container";
import StudyCompletionChart from "../charts/study-completion-chart";

import * as studyCompletion from "../../services/visualization/study-completion";
import { downloadCSV } from "../../services/visualization/data-management";
import Loading from "vue-loading-overlay";

Vue.use(Loading);

function calculatePercentageCompletedStatus(value = 0, totalData = 0) {
  return !isNaN((Number(value) / Number(totalData)) * 100) ? (Number(value) / Number(totalData)) * 100 : 0;
}

function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

export default {
  components: {
    ChartContainer,
    "study-completion": StudyCompletionChart
  },

  props: {
    dataSources: [Object, null],
    siteListInParticipants: [Array, []],
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => {} },
    titleChart: { type: String, default: "" },
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false },
    participantsSelected: [Array, null],
    filterDate: { type: Array, default: () => [] },
    onFilterDate: { type: Boolean }
  },

  data() {
    return {
      downloadId: "completion-data",
      width: "100%",
      height: "250px",
      zoomGraphValueChild: "",
      todayDate: "",
      tDateShow: true,
      matrix: [],
      // newMatrix: [],
      total: {
        notCompleted: 0,
        upcoming: 0,
        onGoing: 0,
        completed: 0
      },
      totalActivity: {
        notCompleted: 0,
        upcoming: 0,
        onGoing: 0,
        completed: 0
      },
      scroll: "first"
    };
  },

  methods: {
    processVisualizationData() {
      let matrixData = null;
      let totalCompleted = 0;
      let total = {};

      if (this.dataSources && !_.isEmpty(this.siteListInParticipants)) {
        matrixData = studyCompletion.generateHeatmapData(this.dataSources.locations, this.countrySelected, this.sitesSelected, this.siteListInParticipants, this.participantsSelected, this.filterDate);
      }

      if (this.scroll === "vertical") {
        if (!_.isEmpty(matrixData)) {
          const index = _.findIndex(this.matrix, {
            orderYAxis: matrixData[0].orderYAxis
          });
          if (index < 0) {
            const newMatrix = this.matrix.concat(matrixData);
            this.matrix = newMatrix;
          }
        }
      }
      if (this.scroll === "horizontal") {
        const newMatrix = this.matrix;
        // this.matrix = []
        this.matrix.map((row, index) => {
          const find = _.find(matrixData, { orderYAxis: row.orderYAxis });
          if (!_.isEmpty(find)) {
            const activity = find.matrixActivities;
            const newActivity = _.unionWith(newMatrix[index].matrixActivities, activity);
            newMatrix[index].matrixActivities = newActivity;
            const totalPercentageCompleted = calculatePercentageCompletedStatus(newMatrix[index].percentage.totalCompletedStatus + find.percentage.totalCompletedStatus, newMatrix[index].percentage.totalStatusWithoutNotScheduled + find.percentage.totalStatusWithoutNotScheduled);
            newMatrix[index].totalPercentageCompleted = totalPercentageCompleted || 0;
          }
        });
        this.matrix = newMatrix;
      }
      if (this.scroll === "first") {
        this.matrix = matrixData;
      }

      totalCompleted = studyCompletion.calculateStudyWithActivitiesCompleted(this.matrix);
      total = studyCompletion.calculateStudyWithActivities(this.matrix);

      const newTotalActivity = {
        notCompleted: 0,
        upcoming: 0,
        onGoing: 0,
        completed: 0
      };
      this.matrix = this.matrix || [];
      this.matrix.forEach(row => {
        const notCompleted = row.matrixActivities.filter(o => o.status === "NotComplete");
        const upcoming = row.matrixActivities.filter(o => o.status === "Upcoming");
        const onGoing = row.matrixActivities.filter(o => o.status === "Ongoing");
        const completed = row.matrixActivities.filter(o => o.status === "Completed");

        newTotalActivity.notCompleted += notCompleted.length;
        newTotalActivity.upcoming += upcoming.length;
        newTotalActivity.onGoing += onGoing.length;
        newTotalActivity.completed += completed.length;
      });
      const totalResult = {
        notCompleted: total.totalNotCompleted,
        upcoming: total.totalUpcoming,
        onGoing: total.totalOngoing,
        completed: totalCompleted
      };

      this.totalActivity = newTotalActivity;
      this.total = totalResult;
    },

    handleDownloadCsv(title) {
      if (_.isEmpty(this.matrix)) {
        return;
      }
      const headerCsv = ["Country", "Site", "Thread ID", "Participant ID"];
      const headerActivity = [];
      this.matrix = this.matrix || [];
      this.matrix.forEach(row => {
        row.matrixActivities.forEach(row2 => {
          const index = _.findIndex(headerActivity, ["activityName", row2.activityName]);
          if (index < 0) {
            headerActivity.push({
              activityName: row2.activityName,
              scheduledDays: row2.scheduledDays
            });
          }
        });
      });

      _.orderBy(headerActivity, ["scheduledDays", d => d.activityName.toLowerCase()], ["asc", "asc"]).map(row => {
        headerCsv.push(row.activityName);
      });

      headerCsv.push("Completion Percentage");

      const dataCsv = [];
      this.matrix = this.matrix || [];
      this.matrix.forEach(row => {
        const activities = [];

        activities.push(row.country);
        activities.push(row.site);
        activities.push(row.participants.threadID);
        activities.push(row.participants.participantId);

        row.matrixActivities.forEach(row2 => {
          const index = _.findIndex(headerCsv, o => {
            return o == row2.activityName;
          });

          if (row2.status == "NotComplete") {
            activities[index] = "Not Completed";
          } else if (row2.status == "Ongoing") {
            activities[index] = "On Going";
          } else {
            activities[index] = row2.status;
          }
        });

        activities[headerCsv.length - 1] = isFloat(row.totalPercentageCompleted) ? row.totalPercentageCompleted.toFixed(2) + "%" : row.totalPercentageCompleted + "%";
        dataCsv.push(activities);
      });

      downloadCSV(title, headerCsv, dataCsv, this.specificSiteId);
    },

    zoomGraph(status) {
      if (status) {
        if (this.matrix.length === 10) {
          this.onScrollTable();
        }
        this.zoomGraphValueChild = true;
        this.height = "520px";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250px";
        this.$emit("zoomDisabled");
      }
    },

    onScrollTable(scrollDirection) {
      this.scroll = scrollDirection;
      this.$emit("onScrollTable", scrollDirection);
    }
  },

  watch: {
    dataSources() {
      this.processVisualizationData();
    },

    countrySelected() {
      this.scroll = "first";
      this.processVisualizationData();
    },

    sitesSelected() {
      this.scroll = "first";
      this.processVisualizationData();
    },

    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250px";
      }
    },

    participantsSelected() {
      this.scroll = "first";
      this.processVisualizationData();
    },

    onFilterDate() {
      this.scroll = "first";
      this.processVisualizationData();
    },

    siteListInParticipants() {
      this.scroll = "first";
      this.processVisualizationData();
    }
  }
};
</script>
